import React from "react"
import { Modal, Form, Col, Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { connect } from "react-redux"
import ActionButton from "../ActionButton"
import { APIError } from "../../api/ObservableFromFetch"
import { RouteComponentProps } from "react-router"
import { Home } from "../../config/Routes"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import PermissionsSubscriptionModal from "./RolesPermissions/PermissionsSubscriptionModal"
import { AppState } from "../../AppState"
import { getUserNameForSelectedCompany } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import ApproveNewPermissionsModal from "./RolesPermissions/ApproveNewPermissionsModal"
import PermissionsRoleModal from "./RolesPermissions/PermissionsRoleModal"
import ApproveRolePermissionsModal from "./RolesPermissions/ApproveRolePermissionsModal"
import ApproveSubscriptionRelationshipsModal from "./RolesPermissions/ApproveSubscriptionRelationshipsModal"

interface PermissionsSelectionProps {
}

interface PermissionsSelectionAuthProps {
  UserName?: string
}

enum PermissionSelectionType {
  PermissionsSubscription = "permSubs",
  PermissionsRole = "permRole",
  ApproveNewPermissions = "approvePerms",
  ApproveSubscriptions = "approveSubs",
  ApproveRoles = "approveRoles",
  NoSelection = ""
}

interface PermissionsSelectionState {
  selected: PermissionSelectionType
  showSelection: boolean
  showPermissionsSubscriptionModal: boolean
  showPermissionsRoleModal: boolean
  showApproveNewPermissionsModal: boolean
  showApproveSubscriptionsModal: boolean
  showApproveRolesModal: boolean
}

export class PermissionsSelection extends React.PureComponent<PermissionsSelectionProps & PermissionsSelectionAuthProps, PermissionsSelectionState> {
  emptyState: PermissionsSelectionState = {
    selected: PermissionSelectionType.NoSelection,
    showSelection: true,
    showPermissionsSubscriptionModal: false,
    showPermissionsRoleModal: false,
    showApproveNewPermissionsModal: false,
    showApproveSubscriptionsModal: false,
    showApproveRolesModal: false
  }
  state: PermissionsSelectionState = { ... this.emptyState }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  handleCancel = () => (this.props as RouteComponentProps).history?.push(Home)
  handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => this.setState({ selected: e.target.value as PermissionSelectionType })
  handleNext = () => {
    this.setState({
      showSelection: false,
      showPermissionsSubscriptionModal: this.state.selected === PermissionSelectionType.PermissionsSubscription,
      showPermissionsRoleModal: this.state.selected === PermissionSelectionType.PermissionsRole,
      showApproveNewPermissionsModal: this.state.selected === PermissionSelectionType.ApproveNewPermissions,
      showApproveSubscriptionsModal: this.state.selected === PermissionSelectionType.ApproveSubscriptions,
      showApproveRolesModal: this.state.selected === PermissionSelectionType.ApproveRoles
    })
  }

  handleModalCancel = () => this.setState({ ... this.emptyState })

  render() {
    const { selected, showSelection, showPermissionsSubscriptionModal, showApproveNewPermissionsModal, showApproveSubscriptionsModal, showPermissionsRoleModal, showApproveRolesModal } = this.state

    return (
      <AppPageWrapper showNav>
        {showSelection && <Modal.Dialog size="lg">
          <Modal.Header>
            <Modal.Title className="text-uppercase">Subscription/Role/Permission Selection</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row className="form-group">
              <Col lg={2}>I Would Like To:</Col>
            </Form.Row>
            <Form.Row className="form-group">
              <Col lg={2}></Col>
              <Col lg={7}>
                <Form.Group className="section-border">
                  <Form.Check label="Add Permissions to a Subscription"
                    id="permtosubs-radio"
                    type="radio"
                    name="selectionType"
                    className="abc-radio p-1"
                    value={PermissionSelectionType.PermissionsSubscription}
                    checked={selected === PermissionSelectionType.PermissionsSubscription}
                    onChange={this.handleSelect} />
                  <Form.Check label="Add Permissions to a Role"
                    id="permtorole-radio"
                    type="radio"
                    name="selectionType"
                    className="abc-radio p-1"
                    value={PermissionSelectionType.PermissionsRole}
                    checked={selected === PermissionSelectionType.PermissionsRole}
                    onChange={this.handleSelect} />
                  <Form.Check label="Approve New Permissions"
                    id="newperm-radio"
                    type="radio"
                    name="selectionType"
                    className="abc-radio p-1"
                    value={PermissionSelectionType.ApproveNewPermissions}
                    checked={selected === PermissionSelectionType.ApproveNewPermissions}
                    onChange={this.handleSelect} />
                  <Form.Check label="Approve Subscriptions/Permissions Relationship"
                    id="approvesubs-radio"
                    type="radio"
                    name="selectionType"
                    className="abc-radio p-1"
                    value={PermissionSelectionType.ApproveSubscriptions}
                    checked={selected === PermissionSelectionType.ApproveSubscriptions}
                    onChange={this.handleSelect} />
                  <Form.Check label="Approve Roles/Permissions Relationship"
                    id="approverole-radio"
                    type="radio"
                    name="selectionType"
                    className="abc-radio p-1"
                    value={PermissionSelectionType.ApproveRoles}
                    checked={selected === PermissionSelectionType.ApproveRoles}
                    onChange={this.handleSelect} />
                </Form.Group>
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" className="mr-2" onClick={() => this.handleCancel()}>Cancel</Button>
            <ActionButton variant="primary" onClick={() => this.handleNext()} disabled={!selected} >Next</ActionButton>
          </Modal.Footer>
        </Modal.Dialog>}

        {showPermissionsSubscriptionModal && <PermissionsSubscriptionModal onCancel={() => this.handleModalCancel()} userName={this.props.UserName} />}
        {showApproveNewPermissionsModal && <ApproveNewPermissionsModal onCancel={this.handleModalCancel} userName={this.props.UserName} />}
        {showApproveSubscriptionsModal && <ApproveSubscriptionRelationshipsModal onCancel={this.handleModalCancel} userName={this.props.UserName} />}
        {showPermissionsRoleModal && <PermissionsRoleModal onCancel={() => this.handleModalCancel()} userName={this.props.UserName} />}
        {showApproveRolesModal && <ApproveRolePermissionsModal onCancel={() => this.handleModalCancel()} userName={this.props.UserName} />}
      </AppPageWrapper>
    )
  }

}

function mapStateToProps(state: AppState): PermissionsSelectionProps {
  return {
    UserName: getUserNameForSelectedCompany(state)
  }
}
const ConnectedPermissionsSelection = connect(mapStateToProps, null)(PermissionsSelection)
export default ConnectedPermissionsSelection